var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content-box"},[_c('router-link',{staticClass:"box-container",attrs:{"to":_vm.link}},[_c('div',{staticClass:"box is-flex is-horizontal-center"},[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})])]),_vm._v(" "),_c('div',{staticClass:"box-title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34ec4580","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box.vue
// module id = null
// module chunks = 